import { ApiSuccessSchema } from "../../common/response.schema";
import type { InferSchemas } from "../../schema-inference";
import { ExportDashboardDataQuerySchema } from "./schemas/export-dashboard-data.schema";
import {
  GetDashboardDataQuerySchema,
  GetDashboardDataResponseSchema
} from "./schemas/get-dashboard-data.schema";

/**
 * Dashboard API Schemas
 *
 * Type-safe API contracts for dashboard endpoints.
 */

export const ZDashboard = {
  /**
   * GET /api/dashboard
   * Get organization dashboard metrics
   */
  GetDashboardData: {
    method: "GET" as const,
    path: "/api/dashboard",
    Params: GetDashboardDataQuerySchema,
    Response: ApiSuccessSchema(GetDashboardDataResponseSchema)
  },

  /**
   * GET /api/dashboard/export
   * Export dashboard data as CSV
   */
  ExportDashboardData: {
    method: "GET" as const,
    path: "/api/dashboard/export",
    Params: ExportDashboardDataQuerySchema,
    responseType: "blob" as const // Binary response (CSV file)
  }
} as const;

export type TApiDashboard = InferSchemas<typeof ZDashboard>;
